module.exports = __webpack_public_path__ + "static/media/Web.b070ef11.svg";